import React from "react";

export type Course = {
  id: string;
  title: string;
  location: string;
  category: string;
  shortDescription: string;
  startDate: string;
  duration: string;
  imageUrl?: string;
  pageContent?: string;
  registrationEmail?: string;
  hidden?: boolean;
};

export default function CourseCard({ course, onRegister }: { course: Course; onRegister: (c: Course) => void }) {
  const imageUrl = course.imageUrl ? encodeURI(course.imageUrl) : "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";

  return (
    <div className="card cursor-pointer group h-full flex flex-col" onClick={() => onRegister(course)}>
      <div className="relative w-full overflow-hidden -mx-6 -mt-6 rounded-t-xl aspect-[16/9] flex-shrink-0">
        <img src={imageUrl} alt={course.title} className="w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-110" />
      </div>
      <div className="p-4 flex-grow flex flex-col">
        <span className="inline-block mx-auto text-center text-xs font-semibold px-2 py-1 rounded-full bg-blue-100 text-blue-600 mb-2">{course.category}</span>
        <h3 className="text-lg font-semibold text-slate-800 group-hover:text-blue-500 transition-colors mb-3">{course.title}</h3>
        <p className="text-sm text-slate-600 flex-grow mb-4">{course.shortDescription}</p>
        <div className="pt-4 border-t border-slate-200 flex flex-col gap-2 text-sm text-slate-500 mt-auto">
          <div className="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
            <span>{course.startDate}</span>
          </div>
          <div className="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>Duración: {course.duration}</span>
          </div>
          <div className="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
            <span>{course.location}</span>
          </div>
        </div>
        <button
          className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onRegister(course);
          }}
        >
          ¡Inscríbete!
        </button>
      </div>
    </div>
  );
}
